import { render } from "./productVariations.vue?vue&type=template&id=6dc0ff28"
import script from "./productVariations.vue?vue&type=script&lang=js"
export * from "./productVariations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__